import React from "react";
import { Progress } from "@/components/ui/progress";
import { Flame } from "lucide-react";

export const XPHeader = ({ progress, streak }) => {
  if (!progress) return null;
  return (
    <div className="litra-card p-5" data-testid="xp-header">
      <div className="flex items-center justify-between mb-3 flex-wrap gap-2">
        <div>
          <div className="text-xs text-[var(--bone-faint)] mono-chip">LEVEL {progress.level}</div>
          <div className="text-xl font-display font-semibold" data-testid="dashboard-rank-label">{progress.rank}</div>
        </div>
        <div className="flex items-center gap-3">
          <div className="flex items-center gap-1.5 text-sm" data-testid="dashboard-streak-count">
            <Flame className="w-4 h-4 gold-text" /> <span>{streak || 0} day streak</span>
          </div>
          <div className="text-sm text-[var(--bone-muted)]">{progress.xp} XP</div>
        </div>
      </div>
      <Progress value={progress.progress_pct} className="h-2 bg-white/[0.06]" data-testid="dashboard-xp-progress" />
      <div className="mt-1.5 text-xs text-[var(--bone-faint)]">
        {progress.next_threshold ? `${progress.next_threshold - progress.xp} XP to next rank` : "Max rank reached — Master of Litrametry"}
      </div>
    </div>
  );
};

export default XPHeader;
